import {
  AuctionBiddingStatus,
  AuctionResponse,
  formatDateRange,
} from '@bonhams1793/bonhams-typescript'
import { isAfter } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

import { getTranslate } from '@nx/translations'

import translate from './EndingFrom.translate.json'

const { text } = getTranslate(translate)

export function EndingFrom({ auction }: EndingFromProps) {
  let formattedDate: string
  const nowDate = toZonedTime(
    new Date(),
    auction.dates.start[0].date.timezone.iana
  )
  const startDate = toZonedTime(
    auction.dates.start[0].date.datetime,
    auction.dates.start[0].date.timezone.iana
  )
  const endDate = toZonedTime(
    auction.dates.end.datetime,
    auction.dates.start[0].date.timezone.iana
  )

  // Auction is yet to happen, or already happened.
  if (
    (isAfter(startDate, nowDate) || isAfter(nowDate, endDate)) &&
    auction.sBidOnlineStatus !== AuctionBiddingStatus.inProgress
  ) {
    formattedDate = formatDateRange({
      startDate: auction.dates.start[0].date.datetime,
      endDate: auction.dates.end.datetime,
      timeZone: auction.dates.start[0].date.timezone.iana,
      timezoneAbbreviation: auction.dates.hammer?.timezone.abbreviation,
    })
  } else {
    formattedDate = text('endingFrom', {
      date: formatDateRange({
        startDate: auction.dates.end.datetime,
        endDate: auction.dates.end.datetime,
        timeZone: auction.dates.start[0].date.timezone.iana,
        timezoneAbbreviation: auction.dates.hammer?.timezone.abbreviation,
      }),
    })
  }

  return <div>{formattedDate}</div>
}

export interface EndingFromProps {
  auction: AuctionResponse
}
